export default "__VITE_ASSET__BGN2pfX$__"